import { compose } from 'redux'

// Use devtools compose or fall back to redux compose if devtools don't exist.
export default () => window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
